const addBundleCart = async(products, isChecked) => {

    console.log(products)

    let formData = {'items': []};

    products.forEach(item => {
        if (item.id === 36336151265432) {
            if (item.selling_plan_allocation) {
                formData.items.push({ quantity: item.quantity, id: item.id, selling_plan: 5062754540 });
            } else {
                formData.items.push({ quantity: item.quantity, id: item.id, selling_plan: null });
            }
        } else {
            if(isChecked) {
                formData.items.push({ quantity: item.quantity, id: item.id, selling_plan: 5151228140 });
            } else {
                formData.items.push({ quantity: item.quantity, id: item.id, selling_plan: null });
            }
        }
    });
    
    Shopify.theme.jsAjaxCart.customAddToCartBulk(formData);
}

const getProduct = async() => {
    
}

const clearBundle = async(products, isChecked) => {
    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
    })
    .then(response => response.json())
    .then(data => {
        addBundleCart(products, isChecked);
    })
    .catch((error) => {
        console.error('Error:', error);
    });    
}


const updateChangeCart = async(product_id, selling_plan, qty) => {
    let formData = {
        'id': product_id,
        'selling_plan': selling_plan,
        'quantity': qty
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        Shopify.theme.jsAjaxCart.updateView();
    })
    .catch((error) => {
        console.error('Error:', error);
    });

}

function reemplazarDivConButton() {
    var divElement = $(".PCPreviewbutton");

    if (divElement.length > 0) {
        divElement.replaceWith(function() {
            return $("<button>", { class: divElement.attr("class") + " gf_gs-button-cart-button", }).html(divElement.html());
        });

        return true;
    }

    return false;
}

$(document).on('click', '.rebuy-button', function(e) {
    e.preventDefault();

    var dataKey = $(this).data("cart-item-key");
    var dataSelling = $(this).data("selling-plan");
    var dataQty = $(this).data("product-qty");

    updateChangeCart(dataKey, dataSelling, dataQty);
    return false;
});

$(document).on('click', '#toggle-btn2', function(e) {
    e.preventDefault();

    let isChecked = $(this).is(':checked');

    if(window.productsArray.length > 0) {
        let products = window.productsArray;

        clearBundle(products, isChecked);
    }
});

$(document).on('change', '.rebuy-cart__flyout-item-subscription .rebuy-select', function(e) {
    e.preventDefault();

    var dataKey = $(this).data("cart-item-key");
    var dataSelling = $(this).val();
    var dataQty = $(this).data("product-qty");

    updateChangeCart(dataKey, dataSelling, dataQty);
    return false;
});

$(document).ready(function() {
    var intervalID = setInterval(function() {
        if (reemplazarDivConButton()) {
            clearInterval(intervalID);
        }
    }, 1000);

    Shopify.theme.jsAjaxCart.renderSelect();
    $('.skio-test').parent().parent().css('z-index', 2);

    $(document).on("click", '[data-ajax-cart-trigger]', function(event) {
        Shopify.theme.jsAjaxCart.renderSelect();
    });

    $(document).on('click', '.PCPreviewbutton', function(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();

        setTimeout(function() {
            $('.AddToCartForm [type="submit"]').click();
        }, 200)

    })

    $(document).on('click', '.button-add-to-cart', function(event) {
        event.preventDefault();
        
        let $idProduct = $(this).data('product-id');
        let selling_plan = '';

        Shopify.theme.jsAjaxCart.customAddToCart($idProduct, selling_plan, 1);

        // addToCart($idProduct, selling_plan)
    });
});


const emailLink = document.querySelector('#toggle-btn');

if(emailLink) {
    emailLink.addEventListener('click', () => {

        var stateCheck = emailLink.checked ? 'On' : 'Off';
    
        gtag('event', 'link_click', {
            event_category: 'Subscription',
            event_action: 'Click',
            event_label: `Subscrition toggle ${stateCheck}`
        });
    
    }, { once: true });
}

